module.exports = __webpack_public_path__ + "media/application/images/placeholder@2x-f700e47c94035d05eeec776d937af7e8.jpg";